import Vue from 'vue';

export function getProductList(data) {
  return Vue.axios({
    url: '/sandbox/product/list',
    method: 'post',
    data,
  });
}

export function createOrder(data) {
  return Vue.axios({
    url: '/sandbox/order/create',
    method: 'post',
    data,
  });
}

export function confirmedOrder(data) {
  return Vue.axios({
    url: '/sandbox/order/confirmed',
    method: 'post',
    data,
  });
}

export function cancelledOrder(data) {
  return Vue.axios({
    url: '/sandbox/order/cancelled',
    method: 'post',
    data,
  });
}

export function shippedOrder(data) {
  return Vue.axios({
    url: '/sandbox/order/shipped',
    method: 'post',
    data,
  });
}

export function getStockLocation() {
  return Vue.axios({
    url: '/sandbox/order/locations',
  });
}

export function getCancelReasonCodes() {
  return Vue.axios({
    url: '/sandbox/order/cancelReasonCodes',
  });
}

export function getOrderList(data) {
  return Vue.axios({
    url: '/sandbox/order/list',
    method: 'post',
    data,
  });
}

export function getLogisticsTypes() {
  return Vue.axios({
    url: '/sandbox/order/logisticsTypes',
  });
}

export function getProductDetail(params) {
  return Vue.axios({
    url: '/sandbox/product/detail',
    params,
  });
}

export function cancelIMOrder(params) {
  return Vue.axios({
    url: '/sandbox/order/IMCancelled',
    method: 'post',
    params,
  });
}

export function getExceptionByOrderLineNum(params) {
  return Vue.axios({
    url: '/sandbox/order/getExceptionByOrderLineNum',
    params,
  });
}
